import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_ACTIVITIES } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={CFRD_ACTIVITIES} id={id} />;
}

export const Route = createFileRoute("/_app/cfrd/activities/$id")({
  component: Edit,
});
